module.exports = __webpack_public_path__ + "04_glasses_blue.37159f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/04_glasses_blue.png
// module id = B45j
// module chunks = 0